<script lang="ts">
	import { goto } from '$app/navigation';
	import Table from '#lib/components/Table.svelte';
	import { getTeamImageUrl } from '#lib/hockeydata/hockeydata.js';
	import type { HDScheduleResponseRow } from '#lib/hockeydata/types/responses/Schedule.js';
	import type { TableCol } from '#lib/hockeydata/types/util/TableCol.js';
	import { faCircle } from '@fortawesome/free-solid-svg-icons';
	import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
	import dayjs from 'dayjs';

	const { data: layoutData } = $props();

	const gamesCols: TableCol[] = [
		{
			key: 'scheduledDate',
			label: 'Datum',
			sortable: true,
			sortFunction: (a: HDScheduleResponseRow) => a.scheduledDate.sortValue,
			class: 'justify-start'
		},
		{
			key: 'score',
			label: 'Ergebnis',
			sortable: true
		},
		{
			key: 'opponentTeamShortname',
			label: 'Gegner',
			class: 'justify-start',
			sortable: true
		},
		{
			key: 'isHomeGame',
			label: 'Heim/Auswärts',
			class: 'justify-center',
			sortable: true
		}
	];
</script>

<Table
	columns={gamesCols}
	rows={layoutData.team.data.games}
	title={'Spiele'}
	onSelect={(row) => goto(`/match/${row.id}`)}
>
	{#if layoutData.team.data.games?.length === 0}
		<div class="text-primary text-center">Keine Spiele gefunden</div>
	{/if}
	{#snippet data(row, col, getRowData)}
		{#if col.key === 'scheduledDate'}
			<div class="flex flex-col items-start">
				<div>
					{dayjs(row.scheduledDate.sortValue).format('DD.MM.YYYY')}
				</div>
				<div class="text-xs">
					{row.scheduledTime}
				</div>
			</div>
		{:else if col.key === 'score'}
			<div class="flex items-center justify-center gap-1 text-left">
				{#if row.gameVictoryState === 'W'}
					<span class="tooltip tooltip-bottom text-green-500" data-tip="Sieg">
						<FontAwesomeIcon icon={faCircle}></FontAwesomeIcon>
					</span>
				{:else if row.gameVictoryState === 'L'}
					<span class="tooltip tooltip-bottom text-red-500" data-tip="Niederlage">
						<FontAwesomeIcon icon={faCircle}></FontAwesomeIcon>
					</span>
				{:else if row.gameVictoryState === 'OTW'}
					<span class="tooltip tooltip-bottom text-red-300" data-tip="Sieg nach Verlängerung">
						<FontAwesomeIcon icon={faCircle}></FontAwesomeIcon>
					</span>
				{:else}
					<span
						class="tooltip tooltip-bottom text-green-300"
						data-tip="Niederlage nach Verlängerung"
					>
						<FontAwesomeIcon icon={faCircle}></FontAwesomeIcon>
					</span>
				{/if}
				<span class="w-[5ch] text-center">{row.score}</span>
			</div>
		{:else if col.key === 'opponentTeamShortname'}
			<div class="flex flex-row items-center gap-2">
				<img
					src={getTeamImageUrl(row.opponentTeamId, layoutData.season?.seasonId ?? '')}
					alt={row.opponentTeamShortname}
					class="mb-1 hidden aspect-square h-8 object-contain md:block"
				/>
				<span>
					{row.opponentTeamShortname}
				</span>
			</div>
		{:else if col.key === 'isHomeGame'}
			{row.isHomeGame ? 'Heim' : 'Auswärts'}
		{:else}
			{getRowData(row, col.key)}
		{/if}
	{/snippet}
</Table>
